import React from 'react';

function LoadingScreen() {
  return (
    <div className="fixed inset-0 bg-white flex items-center justify-center z-50">
      <div className="text-center">
        <div className="loading-spinner mb-4">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-pear"></div>
        </div>
        <p className="text-gray-600 text-lg">Loading GetViza.ai...</p>
      </div>
    </div>
  );
}

export default LoadingScreen; 